import type { NavItem } from './navigation';
import { navigation } from './navigation';

export const useNavigation = (): NavItem[] => navigation;
